import React, { ChangeEvent, ReactNode } from 'react';
import Checkbox from '../../atomsLegacy/Checkbox';
import { CheckboxContainer, CheckboxLabel } from './CheckboxWithLabel.styles';

export interface CheckboxWithLabelProps {
  /**
   * Label contents.
   */
  label?: string;
  /**
   * If true, the component is checked.
   */
  checked: boolean;
  /**
   * Optional change handler.
   */
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  fontSize?: string;
  fontWeight?: 'regular' | 'light' | 'bold';
  /**
   * Optional children (can be used in the case that the label text is not a string).
   */
  checkboxLabel?: ReactNode;
  checkboxColor?: string;
}

/**
 * Checkbox with label, used throughout CSV Upload flow.
 */
export const CheckboxWithLabel: React.FC<CheckboxWithLabelProps> = ({
  onChange,
  checked,
  label,
  fontSize,
  fontWeight,
  checkboxLabel,
  checkboxColor,
  ...props
}: CheckboxWithLabelProps) => {
  return (
    <CheckboxContainer data-testid="checkbox-label-container">
      <Checkbox
        checked={checked}
        onChange={onChange}
        {...props}
        colorOverride={checkboxColor}
      />
      <CheckboxLabel label={label} fontSize={fontSize} weight={fontWeight}>
        {checkboxLabel}
      </CheckboxLabel>
    </CheckboxContainer>
  );
};

export default CheckboxWithLabel;
